// extracted by mini-css-extract-plugin
module.exports = {"root":"NoLoansPanel_root__1FVlA","hide":"NoLoansPanel_hide__1ACSP","description":"NoLoansPanel_description__1zWvh","buttons":"NoLoansPanel_buttons__TkLiv"};